import React from 'react';
import { motion } from 'framer-motion';
import { CheckCircle2, Gift } from 'lucide-react';
import { bonuses } from '../data/bonuses';
export function BonusSection() {
  return <section className="py-24 px-4 bg-white border-y border-[#E6D5BF]" data-id="element-19" data-mp="22fmv4tjdi00j">
      <div className="max-w-5xl mx-auto" data-id="element-20" data-mp="22divwowf5p6l">
        <div className="text-center mb-16" data-id="element-21" data-mp="1ydi7qcjipzmc">
          <p className="text-[#8A6A2B] font-bold tracking-widest uppercase mb-2" data-id="element-22" data-mp="1yet9k6tekxat">
            Included With Your Purchase at No Additional Cost
          </p>
          <h2 className="text-4xl md:text-5xl font-bold tracking-tight text-[#520128]" data-id="element-23" data-mp="15pw10vezuev9">
            <span className="text-[#8E2C5C]" data-id="element-24" data-mp="1jgitw6y2pajf">5</span> EXCLUSIVE SEWING{' '}
            <span className="text-[#8E2C5C]" data-id="element-25" data-mp="1jilshfdakbzr">INSTRUCTOR BONUSES</span>
          </h2>
          <p className="text-lg text-slate-700/80 max-w-3xl mx-auto mt-5" data-id="element-26" data-mp="1enxzb37ceteu">
            The six main volumes give you visual training material for every core sewing and pattern-making teaching
            area. And the five bonuses add practical tools to help you drill stitches and sewing essentials, script
            your demonstrations, practice pattern drafting at quarter scale, troubleshoot fitting and alterations,
            and assess students with clear competency checklists, rubrics and certificates.
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-6" data-id="element-27" data-mp="2ohiokh91x6kj">
          {bonuses.map((bonus, index) => <motion.article key={bonus.id} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.3,
          delay: index * 0.05,
          ease: [0.23, 1, 0.32, 1]
        }} className={`bg-white border border-[#E6D5BF] rounded-2xl p-8 shadow-sm shadow-[#520128]/5 relative flex flex-col ${index === 4 ? 'md:col-span-2' : ''}`} data-id="element-28" data-mp="1qtqqzm6303cf" data-mpi={index}>
              <div className="absolute top-0 right-0 bg-[#520128] text-white px-4 py-2 rounded-bl-2xl rounded-tr-2xl font-bold text-sm" data-id="element-29" data-mp="3h5548nvk01nr">
                BONUS {bonus.id}
              </div>
              <div className="w-12 h-12 bg-[#F1E6D8] border border-[#C9A24A] rounded-full flex items-center justify-center text-[#8E2C5C] mb-4" data-id="element-30" data-mp="1c4kj8m6l7il0">
                <Gift size={24} data-id="element-31" data-mp="1q3jwkxongb1v" />
              </div>
              <h3 className="text-xl font-bold tracking-tight mb-2 pr-28 text-[#520128]" data-id="element-32" data-mp="1m2ro46nlqa6n">{bonus.title}</h3>
              <p className="text-[#8A6A2B] text-sm font-semibold mb-4 border-l-4 border-[#C9A24A] pl-4" data-id="element-33" data-mp="yce3h17cjdm3">
                {bonus.subtitle}
              </p>
              {bonus.referenceValueCents !== undefined && <p className="flex flex-wrap items-baseline gap-x-2 text-sm mb-4" data-id="element-34" data-mp="1769a6do49c3u">
                  <span className="text-slate-500" data-id="element-35" data-mp="12dzbo98xr3py">Reference value:</span>
                  <span className="text-slate-500 line-through" data-id="element-36" data-mp="eowx5a9llqzo">
                    {formatUsd(bonus.referenceValueCents)}
                  </span>
                  <span className="font-extrabold text-green-700 uppercase tracking-wide" data-id="element-37" data-mp="amjs6o2odx3y">
                    Included free
                  </span>
                </p>}
              {bonus.intro && <p className="text-slate-700 text-sm mb-4 leading-relaxed" data-id="element-38" data-mp="5bfp97kiiyd2">{bonus.intro}</p>}

              {bonus.bullets && <>
                  <p className="text-[#520128] font-semibold text-sm mb-3" data-id="element-39" data-mp="3rowfv57gor7u">{bonus.bulletsIntro}</p>
                  <ul className={`mb-6 ${bonus.bullets.length > 8 ? 'grid sm:grid-cols-2 gap-x-4 gap-y-2' : 'space-y-2'} ${index === 4 ? 'md:grid-cols-4' : ''}`} data-id="element-40" data-mp="j9mgi4uyi03r">
                    {bonus.bullets.map(bullet => <li key={bullet} className="flex items-start gap-3" data-id="element-41" data-mp="e9zzrlfx61q7">
                        <CheckCircle2 size={16} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-42" data-mp="2u273q2j1oy89" />
                        <span className="text-slate-700 text-sm" data-id="element-43" data-mp="2z0s5w7huxrzc">{bullet}</span>
                      </li>)}
                  </ul>
                </>}

              {bonus.detailedBullets && <>
                  <p className="text-[#520128] font-semibold text-sm mb-3" data-id="element-44" data-mp="3afvg41uls1qg">{bonus.bulletsIntro}</p>
                  <ul className="mb-6 space-y-3" data-id="element-45" data-mp="35iv9nptucwyt">
                    {bonus.detailedBullets.map(item => <li key={item.title} className="flex items-start gap-3" data-id="element-46" data-mp="30l3jb08uhiwq">
                        <CheckCircle2 size={16} className="text-[#8E2C5C] shrink-0 mt-0.5" data-id="element-47" data-mp="20bsbicpbbis" />
                        <div data-id="element-48" data-mp="3t8z9rn7tmel2">
                          <span className="block text-[#520128] font-bold text-sm" data-id="element-49" data-mp="3t5v0wcjeuuo2">{item.title}</span>
                          <span className="block text-slate-700 text-sm" data-id="element-50" data-mp="3oaxuzehfh1fe">{item.detail}</span>
                        </div>
                      </li>)}
                  </ul>
                </>}

              {bonus.secondaryBullets && <>
                  <p className="text-[#520128] font-semibold text-sm mb-3" data-id="element-51" data-mp="27ta338sscxfj">
                    {bonus.secondaryBulletsIntro}
                  </p>
                  <ul className="mb-6 grid sm:grid-cols-2 gap-x-4 gap-y-2" data-id="element-52" data-mp="sb43jf3hwi8a">
                    {bonus.secondaryBullets.map(bullet => <li key={bullet} className="text-[#520128] font-semibold text-sm bg-[#F1E6D8] border border-[#E6D5BF] rounded-lg px-3 py-2" data-id="element-53" data-mp="x95ne28qwlkt">
                        {bullet}
                      </li>)}
                  </ul>
                  {bonus.secondaryNote && <p className="-mt-3 mb-6 text-slate-700 text-sm italic" data-id="element-54" data-mp="1g0yets861yqf">{bonus.secondaryNote}</p>}
                </>}

              <div className="mt-auto space-y-3" data-id="element-55" data-mp="1kxykw350n1hj">
                {bonus.system && <div data-id="element-56" data-mp="3hupaidxs6wo8">
                    <p className="text-[#520128] font-semibold text-sm mb-2" data-id="element-57" data-mp="3mro5eyp9r7nh">{bonus.systemLabel}</p>
                    <p className="text-[#520128] font-bold text-xs sm:text-sm tracking-wide bg-[#F1E6D8] border-l-4 border-[#C9A24A] rounded-lg px-3 py-2" data-id="element-58" data-mp="3er00aqdfnroq">
                      {bonus.system}
                    </p>
                  </div>}
                {bonus.result && <div className="bg-[#F8F3EC] border border-[#E6D5BF] border-l-4 border-l-[#520128] rounded-xl p-4" data-id="element-59" data-mp="3jq2rp80hpze8">
                    <span className="text-[#520128] font-bold block mb-1" data-id="element-60" data-mp="1jy6v5ikccpr">RESULT</span>
                    <p className="text-slate-700 text-sm" data-id="element-61" data-mp="3toikrgj2viqd">{bonus.result}</p>
                  </div>}
                {bonus.closing && <div className="pt-4 border-t border-[#E6D5BF]" data-id="element-62" data-mp="b9rk0aycszw4">
                    {bonus.closing.map((line, lineIndex) => <p key={line} className={lineIndex === 0 ? 'text-[#520128] font-extrabold text-base tracking-wide' : 'text-[#520128] font-semibold text-sm italic'} data-id="element-63" data-mp="6dizsj5augi3" data-mpi={lineIndex}>
                        {line}
                      </p>)}
                  </div>}
              </div>
            </motion.article>)}
        </div>
      </div>
    </section>;
}
function formatUsd(cents: number): string {
  return `$${(cents / 100).toFixed(2)} USD`;
}